import { ISelectOption } from 'react-ocean-forms-bootstrap'
import { KomponenteId } from './dto/KomponenteId'
import { AxiosError } from 'axios';
import { ServiceError } from './errors';
import { RequestInfoFormValues } from '../components/Forms';
import { Anforderung } from './model';
import { KomponenteStatus } from '../generated/types';


class ServiceUtilImpl {

  transformSelectJsonToKompId(value: ISelectOption | undefined): KomponenteId {
    if(value && value.value) {
      const json = JSON.parse(value.value);
      return { id: Number(json.id) };
    }
    throw Error('Value not defined');
  }

  transformSelectOptionToKompId(value: ISelectOption | undefined): KomponenteId {
    if(value && value.value){
      return {id: Number(value.value)};
    }
    throw Error('Value not defined');
  }

  transformSelectOptionsToStringList(values: ISelectOption[] | undefined): string[] {
    if(!values) return [];
    const result = values.flatMap((e: ISelectOption) => {
      return e.value;
    });
    return result;
  }

  transformSelectOptionsToKompIdList(values: ISelectOption[] | undefined): KomponenteId[] {
    if(!values) return [];

    const result = values.map<KomponenteId>((k) => {
      return this.transformSelectOptionToKompId(k);
    });
    return result;
  }

  transformSelectJsonsToKompIdList(values: ISelectOption[] | undefined): KomponenteId[] {
    if(!values) return [];

    const result = values.map<KomponenteId>((k) => {
      return this.transformSelectJsonToKompId(k);
    });
    return result;
  }

  transformRequestInfoFormToDto(values: RequestInfoFormValues): Anforderung {
    return {
      anmerkung: values.anmerkung,
      email: values.email,
      zweckOderQuelle: values.zweckOderQuelle
    };
  }

  transformStatusEnumToStatus(value: KomponenteStatus ): string {
    return value.toString();
  }
  
}
export const ServiceUtil = new ServiceUtilImpl();


export function handleServiceError (e: AxiosError): AxiosError | null {
  console.log('error',e, e.response);
  throw new ServiceError(e.response?.status ?? 0, e.response?.data as any);
}
